import React, { Component } from 'react';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
const content = [
  {
    title: 'Great companies are built in the office, with hard work put in by the team.',
    // description:
    //   'Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Cras justo odio, dapibus ac facilisis.',
    // button: 'Read More',
    image: 'https://eldocs.net/slider/1.jpg',
    // user: 'Luan Gjokaj',
    // userProfile: 'https://i.imgur.com/JSW6mEk.png'
  },
  {
    title: 'The strength of the team is each individual member. The strength of each individual member is the team.',
    // description:
    //   'Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur purus sit amet fermentum. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Donec sed odio dui.',
    // button: 'Discover',
    image: 'https://eldocs.net/slider/2.jpg',
    // user: 'Erich Behrens',
    // userProfile: 'https://i.imgur.com/0Clfnu7.png'
  },
  {
    title: 'Motivational message of the year',
    description:
      'If you don’t love your job.. Take a home loan. U will start loving it… take another loan, you will start loving your boss as well. Get married…You will start loving your office as well..',
    // button: 'Buy now',
    image: 'https://eldocs.net/slider/3.jpg',
    // user: 'Bruno Vizovskyy',
    // userProfile: 'https://i.imgur.com/4KeKvtH.png'
  },
  {
    title: 'The only way to achieve the impossible is to love your space',
    // description:
    //   'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Duis mollis, est non commodo luctus, nisi erat porttitor ligula.',
    // button: 'Buy now',
    image: 'https://eldocs.net/slider/5.jpg',
    // user: 'Bruno Vizovskyy',
    // userProfile: 'https://i.imgur.com/4KeKvtH.png'
  },
  // {
  //   title: 'Phasellus volutpat metus',
  //   description:
  //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Duis mollis, est non commodo luctus, nisi erat porttitor ligula.',
  //   button: 'Buy now',
  //   image: 'http://eldocs.net/slider/5.jpg',
  //   user: 'Bruno Vizovskyy',
  //   userProfile: 'https://i.imgur.com/4KeKvtH.png'
  // }
];

class LoginIllustrationV1 extends Component {
  render() {
    return (
      <div className="slider-container">
        <div className="header">
          <img src="https://eldocs.net/eldocs-logo.png" className="logo" alt="eldocs logo"/>
        </div>
        <Slider autoplay={2000}>
          {content.map((item, index) => (
            <div
              key={index}
              className="slider-content"
              style={{ background: `url('${item.image}') no-repeat center center` }}
            >
              <div className="inner">
                <h1>{item.title}</h1>
                <p>{item.description}</p>
                {/* <button>{item.button}</button> */}
              </div>
              {/* <section>
                <img src={item.userProfile} alt={item.user} />
                <span>
                  Posted by <strong>{item.user}</strong>
                </span>
              </section> */}
            </div>
          ))}
        </Slider>
      </div>
    );
  }
}

export default LoginIllustrationV1;



// WEBPACK FOOTER //
// ./src/components/login/LoginIllustrationV1.js